





































import { Component, Vue, Prop } from 'vue-property-decorator';
import OtAutocomplete, { IAutocompleteItem } from '@/components/global/ot-autocomplete.vue';
import { vxm } from '@/store';
import OtButton, { OtBtnSize, OtBtnStyle, OtBtnType } from '@/components/global/ot-button.vue';

export interface IKeyedAutocompleteItem<T> extends IAutocompleteItem<T> {
  key: string;
}

type ItemType = IKeyedAutocompleteItem<unknown>;
type MaybeItemType = ItemType | null | undefined;
type ValueType = ItemType[] | null | undefined;

@Component({
  components: {
    OtButton,
    OtAutocomplete,
  },
})
export default class OtMultiSelectAutocomplete extends Vue {
  // * PROPS
  @Prop() private items!: ItemType[];
  // we could do a prop factory function here, but it doesn't guard against null, which is legit for "there is no value"
  @Prop() private value!: ValueType;
  @Prop({ type: String }) private label?: string;
  @Prop({ type: String }) private placeholder?: string;
  @Prop({ type: String, default: 'item' }) private itemType?: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;

  // set this to false if you need the autocomplete to be able to "hang outside" the parent component, and be wider than the field
  // but be careful, if the parent component is scrollable, sometimes (happens in a dialog) the picker will no longer "follow" the field and it'll look dumb
  @Prop({ type: Boolean, default: true }) private attachToField!: boolean;
  // * REFS

  // * DATA

  // * COMPUTED
  // we never actually want a selected item. But we need a backing variable for all of this to hang together properly
  // DO NOT try and just return undefined or null in the getter. Doesn't work
  private selectedItemPrivate: MaybeItemType = null;
  private get selectedItem(): MaybeItemType {
    return this.selectedItemPrivate;
  }
  private set selectedItem(nextSelectedItem: MaybeItemType) {
    if (nextSelectedItem) {
      if (!this.value || this.value.length === 0) {
        // short circuit, nothing in there already, can just make an array and use that
        this.setValue([nextSelectedItem]);
      } else {
        const nextSelectedItemKey = nextSelectedItem.key;

        const itemAlreadySelected = this.value.some(existingItem => {
          return nextSelectedItemKey === existingItem.key;
        });

        if (!itemAlreadySelected) {
          this.setValue([...this.value, nextSelectedItem]);
        }
      }

      // we don't actually want a selected value to show up in the autocomplete
      this.resetSelectedItem();
    }
  }

  private async resetSelectedItem() {
    // Yes. This is WEIRD. No, I do not know why
    // without this null then undefined, it works to clear the FIRST time, but every clear after that fails to actually clear
    // so, set to null, wait, then set to undefined, clears it out all the time every time
    this.selectedItemPrivate = null;
    await this.$nextTick();
    this.selectedItemPrivate = undefined;
  }

  // TODO consider a computed items property that returns the incoming items except the incoming value

  private setValue(nextValue: ValueType) {
    this.$emit('input', nextValue);
  }

  // * WATCHERS

  // * METHODS

  // TODO a remove by index, callable from the chip
  private deselect(item: ItemType) {
    if (!this.value) {
      return;
    }
    this.setValue(this.value.filter(v => v.key !== item.key));
  }

  // * LIFECYCLE
}
